var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"#f5f5f5"}},[_c('v-btn',{staticClass:"social-button",attrs:{"color":"#CDDC39","height":"50"}},[_vm._v(_vm._s(_vm.$t('Social Intranet')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }